module.exports = __webpack_public_path__ + "static/media/loader.1df8d292.gif";